/**
 * @file scripts/components/header.jsx
 * @description
 * This is the global header for our minisite.
 */
import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import session from '../../utils/session';
import settings from '../../utils/settings';
import perms from '../../utils/permissions';
import urlHandler from '../../utils/urlHandler';
import FinchButton from '../demo/FinchButton';
import RequestAccountDialog from '../misc/RequestAccountDialog';
import PackageDialog from '../misc/PackageDialog';
import APIKeyDialog from '../misc/APIKeyDialog';
import TermsOfService from '../../styles/docs/FinchComputing_TermsOfService.pdf';
import { BroadcastChannel } from 'broadcast-channel';
import ReactTooltip from 'react-tooltip';
import history from '../../utils/history';

class Header extends Component {

    constructor(props) {
        super(props);

        this.handleLogout = this.handleLogout.bind(this);
        this.login = this.login.bind(this);
        this.contact = this.contact.bind(this);

        this.kbPermission = false;
        this.usagePermission = false;
        this.versionPermission = true;
        this.iaPermission = false;

        this.state = {
            authenticated: false
        }
    }

    componentWillMount() {
        var search = perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntitySearch']);
        var read = perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntityRead']);
        if (search || read) {
            this.kbPermission = true;         
        } else {
            this.kbPermission = false;            
        }  
        this.usagePermission = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_USAGE);   
        this.versionPermission = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_VERSION);   
        this.iaPermission = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_INTEREST_AREAS);
        this.extractionPermission = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_EXTRACTION);

        this.setState({
            authenticated: session.isAuthenticated()
        })
    }

    componentWillUpdate() {
        var search = perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntitySearch']);
        var read = perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntityRead']);
        if (search || read) {
            this.kbPermission = true;         
        } else {
            this.kbPermission = false;            
        }
        this.usagePermission = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_USAGE);
        this.versionPermission = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_VERSION);
        this.iaPermission = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_INTEREST_AREAS);
        this.extractionPermission = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_EXTRACTION);
    }

    handleLogout() {
        var user = session.getUserName();
        
        settings.setValue('permissions', null);
        session.end();

        // Broadcast logout to other tabs
        var channel = new BroadcastChannel('fft_minisite');
        channel.postMessage({
            type: 'logout',
            user
        })
        channel.close();

        this.setState({
            authenticated: false
        }, () => {
            history.push('/login');
        })
    };
 
    login() {
        history.push('/login');
    };
 
    contact() {
        history.push('/contact');
    };
 
    render() {

        var headerClass = '';
        if (history.location.pathname == '/login') {
            headerClass = 'header-float-login';
        } else if (history.location.pathname == '/') {
            headerClass = 'header-float-landing';
        }

        var userName = '';
        if (session.isAuthenticated()) {
            if (session.getUserName() && session.getUserName() != 'null') {
                userName = session.getUserName();
            }  
        }

        return (
            <header className={`header-wrapper ${headerClass}`}>
                <div className="header">
                    <h1 className="logo-wrapper page-title">
                        <Link to="/" className="logo">
                            {/*<img src={require('../../styles/images/finchForTextLogo.png')}/>*/}
                            Powerful disambiguation and entity extraction | Finch for Text
                        </Link>
                    </h1>
    
                    <nav className="nav-wrapper">
                        <Link to={session.isAuthenticated() ? '/demo' : '/login'} className="nav-link">Demo</Link>
                        {this.kbPermission && session.isAuthenticated() && <Link className="nav-link" to='/knowledgebase'>Knowledgebase</Link> }
                        {this.usagePermission && session.isAuthenticated() && <Link className="nav-link" to='/usage'>API Usage</Link> }
                        {this.iaPermission && session.isAuthenticated() && <Link className="nav-link" to='/interestareas'>Interest Areas</Link> }
                        <Link to="/documentation/doc_overview#top" className="nav-link">API Documentation</Link>
                        {this.extractionPermission && session.isAuthenticated() && <Link to="/admin" className="nav-link">Admin {(this.extractionPermission ? '':'(DISABLED)')}</Link>}
                        {session.isAuthenticated() && <Link to={{pathname:`${window._FFT_webServiceUrl}/swagger/`}} target="_blank" className="nav-link">Swagger API Docs (BETA)</Link>}
                    </nav>
                    <div style={{display:'flex'}}>   
                        {session.isAuthenticated() && this.versionPermission ? 
                            <>
                            <APIKeyDialog tooltip="API Key" tooltipOffset={{bottom: 30}}/> 
                            <PackageDialog tooltip="Version and Package Information" tooltipOffset={{bottom: 30}}/> 
                            </>
                        : 
                            null
                        } 
                        {/* {session.isAuthenticated() ? null : <RequestAccountDialog text="Request login"/>} */}
                        <div>
                            <button className="link-button" onClick={ this.contact } 
                                data-tip 
                                data-for="contact-tip">
                                <span className='fa fa-phone'/>
                            </button>
                            <ReactTooltip id="contact-tip" 
                                    type="dark"
                                    effect="solid" 
                                    place="bottom">
                                    Contact Us
                            </ReactTooltip>
                            <a href={ TermsOfService } className="link-button" target="__blank" 
                                download="FinchComputing_TermsOfService.pdf" data-tip 
                                data-for="terms-tip"> 
                                <span className='fa fa-file-pdf-o'/> 
                            </a>
                            <ReactTooltip id="terms-tip" 
                                    type="dark"
                                    effect="solid" 
                                    place="bottom">
                                    Download Terms of Service
                            </ReactTooltip>
                        </div>
                        <FinchButton
                            warning = {true}
                            text = {session.isAuthenticated() ? 'Log Out' : 'Log In'}
                            submit = {session.isAuthenticated() ? this.handleLogout : this.login}
                            tooltip={session.isAuthenticated() ? `Welcome ${session.getUserName()}`: null}
                            tooltipOffset={{bottom: 15}}>
                        </FinchButton> 
                    </div>
                </div>
            </header>
        );
    }
}
export default Header;